import { useTranslation } from 'react-i18next'

const money = (value) => `${Math.round(value).toLocaleString('mk-MK')} ден`

/**
 * What was earned, and what is left of it.
 *
 * Read top to bottom as a subtraction, because that is what it is: gross in, VAT out (never ours),
 * the payment provider's cut, what the models cost, and what remains. A margin quoted on gross
 * flatters itself by eighteen percent, so the one shown here is on net.
 */
export default function Earnings({ earnings, days }) {
  const { t } = useTranslation()

  if (!earnings) return null

  const rows = [
    { label: t('earnings.gross'), value: earnings.grossMkd, kind: 'in' },
    { label: t('earnings.vat'), value: -earnings.vatMkd, kind: 'out' },
    { label: t('earnings.net'), value: earnings.netMkd, kind: 'sub' },
    { label: t('earnings.fee'), value: -earnings.feeMkd, kind: 'out' },
    { label: t('earnings.models'), value: -earnings.modelMkd, kind: 'out' },
    { label: t('earnings.kept'), value: earnings.keptMkd, kind: 'total' },
  ]

  return (
    <section className="card">
      <h2>{t('earnings.title', { days })}</h2>

      {earnings.grossMkd === 0 ? (
        <>
          <p className="muted">{t('earnings.nothingYet')}</p>
          <p className="small">
            {t('earnings.costSoFar', { cost: money(earnings.modelMkd) })}
          </p>
        </>
      ) : (
        <>
          <table className="ledger">
            <tbody>
              {rows.map((row) => (
                <tr key={row.label} className={row.kind}>
                  <td>{row.label}</td>
                  <td className="num">{money(row.value)}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="stats">
            <div className="stat">
              <div className="stat__value">{earnings.marginPercent}%</div>
              <div className="stat__label">{t('earnings.margin')}</div>
            </div>
            <div className="stat">
              <div className="stat__value">{earnings.payingTenants}</div>
              <div className="stat__label">{t('earnings.paying')}</div>
            </div>
            <div className="stat">
              <div className="stat__value">{money(earnings.averagePerPayingTenantMkd)}</div>
              <div className="stat__label">{t('earnings.perPaying')}</div>
            </div>
            <div className="stat">
              <div className="stat__value">{earnings.costPerActiveTenantMkd.toFixed(2)} ден</div>
              <div className="stat__label">{t('earnings.perActive')}</div>
            </div>
          </div>

          {earnings.byPlan.length > 0 && (
            <>
              <h3>{t('earnings.byPlan')}</h3>
              {earnings.byPlan.map((plan) => (
                <p key={plan.plan} className="row small">
                  <span>
                    {plan.plan} · {plan.count}× · {plan.credits} {t('earnings.credits')}
                  </span>
                  <span>{money(plan.grossMkd)}</span>
                </p>
              ))}
            </>
          )}
        </>
      )}
    </section>
  )
}
